// extracted by mini-css-extract-plugin
export var addButton = "_4u-d";
export var bullets = "_4u-e";
export var compact = "_4u-2";
export var container = "_4u-j";
export var extendedWarrantyModal = "_4u-f";
export var learn = "_4u-l";
export var learnMore = "_4u-g";
export var offeringOption = "_4u-3";
export var offeringPrice = "_4u-8";
export var offeringSubtitle = "_4u-7";
export var offeringTitle = "_4u-6";
export var offeringsContainer = "_4u-0";
export var pdpTilesBackground = "_4u-n";
export var plan = "_4u-m";
export var regular = "_4u-1";
export var remove = "_4u-k";
export var seeDetailsIcon = "_4u-i";
export var seeDetailsLink = "_4u-h";
export var selectedOption = "_4u-4";
export var shieldIcon = "_4u-b";
export var shieldIconCompact = "_4u-c";
export var subtitle = "_4u-a";
export var title = "_4u-9";
export var unselectedOption = "_4u-5";